export const environment = {
    production: true,
    runServiceWorker: false,
    restApi: {
      msB2C: "https://apiqa.argosone.com/qa/adm/b2c/",
    },
    urlsGraphQL: {
      urlGraphQLAccounts: 'https://apiqa.argosone.com/qa/adm/accounts/',
      urlGraphQLGeneral: "https://apiqa.argosone.com/qa/adm/general/",
      content: "https://apiqa.argosone.com/qa/adm/content/",
      back_office: 'https://apiqa.argosone.com/qa/rep/sto/back-office/'
    },
    backgroundImage:"https://stargosone2gqarep.argosone.com/resource/iconStore/FrontBackground.png",
    DefaultRedirect:"https://repdominicanaqa.argosone.com/",
    EncryptKey :"1203199320052021",
    recaptchaSiteKey:"6LdabjEqAAAAAPqFCf0UTwcrNwcNlOL18WitXcBB",
    tenantId :"Republica",
    storeId:"1ADB5C6D-DC99-4BDD-A231-DE40EA2BFAD2",
    x_token: 'cc330a4499e2448cb43190d5ee066aab',
    storeIdComplete:"1ADB5C6D-DC99-4BDD-A231-DE40EA2BFAD2",
    country:"DO"
  };

